module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row3"
  }, [_c('div', {
    staticClass: "imgbg"
  }, [_c('img', {
    attrs: {
      "src": _vm.catelist[0].pic_url
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'ExameApplyList',
        query: {}
      }),
      expression: "{name:'ExameApplyList',query:{}}"
    }],
    staticClass: "btn"
  }, [_vm._v("申报")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: _vm.catelist[0].id
        }
      }),
      expression: "{name:'NewsList',query:{cate_id:catelist[0].id}}"
    }],
    staticClass: "btn",
    staticStyle: {
      "top": "80px"
    }
  }, [_vm._v("展示")])]), _vm._v(" "), _c('div', {
    staticClass: "imgbg"
  }, [_c('img', {
    attrs: {
      "src": _vm.catelist[1].pic_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_vm._v("申报")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: _vm.catelist[1].id
        }
      }),
      expression: "{name:'NewsList',query:{cate_id:catelist[1].id}}"
    }],
    staticClass: "btn",
    staticStyle: {
      "top": "80px"
    }
  }, [_vm._v("展示")])]), _vm._v(" "), _c('div', {
    staticClass: "imgbg"
  }, [_c('img', {
    attrs: {
      "src": _vm.catelist[2].pic_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_vm._v("申报")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: _vm.catelist[2].id
        }
      }),
      expression: "{name:'NewsList',query:{cate_id:catelist[2].id}}"
    }],
    staticClass: "btn",
    staticStyle: {
      "top": "80px"
    }
  }, [_vm._v("展示")])]), _vm._v(" "), _c('div', {
    staticClass: "imgbg"
  }, [_c('img', {
    attrs: {
      "src": _vm.catelist[3].pic_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_vm._v("申报")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: _vm.catelist[3].id
        }
      }),
      expression: "{name:'NewsList',query:{cate_id:catelist[3].id}}"
    }],
    staticClass: "btn",
    staticStyle: {
      "top": "80px"
    }
  }, [_vm._v("展示")])]), _vm._v(" "), _c('div', {
    staticClass: "imgbg"
  }, [_c('img', {
    attrs: {
      "src": _vm.catelist[4].pic_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_vm._v("申报")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "rblink",
      rawName: "v-rblink",
      value: ({
        name: 'NewsList',
        query: {
          cate_id: _vm.catelist[4].id
        }
      }),
      expression: "{name:'NewsList',query:{cate_id:catelist[4].id}}"
    }],
    staticClass: "btn",
    staticStyle: {
      "top": "80px"
    }
  }, [_vm._v("展示")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(row, i) {
    return _c('div', {
      directives: [{
        name: "rblink",
        rawName: "v-rblink",
        value: ({
          name: 'NewsDetail',
          query: {
            id: row.id
          }
        }),
        expression: "{name:'NewsDetail',query:{id:row.id }}"
      }],
      key: i
    }, [(row.pics.length == 0) ? _c('NewsItem1', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (row.pics.length == 1) ? _c('NewsItem2', {
      attrs: {
        "row": row
      }
    }) : _vm._e(), _vm._v(" "), (false) ? _c('NewsItem3') : _vm._e(), _vm._v(" "), (row.pics.length > 1) ? _c('NewsItem4', {
      attrs: {
        "row": row
      }
    }) : _vm._e()], 1)
  }), 0)], 1)], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6aa34e74","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/page/Yundongyuandengji.vue
// module id = 1271
// module chunks = 0